import { useRef, useEffect } from "react";
import { useForm } from "@formspree/react";
import BoothField from "./BoothField";
import "./ContactForm.css";

/** Contact card for the Contact page. onSuccess/onFailure report submission status up. */
function ContactForm({ onSuccess, onFailure }) {
  const [state, handleSubmit, reset] = useForm("mnnzgkdv");
  const formRef = useRef();

  useEffect(() => {
    if (state.succeeded) {
      formRef.current.reset();
      reset();
      onSuccess();
    }
  }, [state.succeeded, reset, onSuccess]);

  useEffect(() => {
    if (state.errors && state.errors.length > 0) {
      onFailure();
      reset();
    }
  }, [state.errors, reset, onFailure]);

  return (
    <div className="booth-contact-card">
      <p className="booth-auth-eyebrow">Get in touch</p>
      <h1 className="booth-auth-title">Contact us</h1>
      <p className="booth-contact-dek">
        Questions, feedback, or a bug to report — the newsroom reads every message.
      </p>
      <form ref={formRef} onSubmit={handleSubmit} className="booth-auth-form booth-contact-form" noValidate>
        <div className="booth-contact-row">
          <BoothField id="contact-first-name" label="First name" name="first-name" required autoComplete="given-name" />
          <BoothField id="contact-last-name" label="Last name" name="last-name" required autoComplete="family-name" />
        </div>
        <BoothField id="contact-email" label="Email" name="email" type="email" required autoComplete="email" />
        <BoothField id="contact-message" label="Message" name="message" required multiline rows={4} />
        <button
          type="submit"
          className="booth-btn booth-btn--primary booth-auth-submit"
          disabled={state.submitting}
        >
          Send <span aria-hidden="true">→</span>
        </button>
      </form>
    </div>
  );
}

export default ContactForm;
